import IconBanner from './IconBanner';

export default IconBanner;
